



































import { Component, Vue } from "vue-property-decorator";
import { Categoria, CategoriasService } from "@/services/categorias.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";

@Component({
  components: {
    Loading,
    Modal,
  },
})
export default class Manter extends Vue {
  categoria: Categoria | null = null;
  categoriaPai: Categoria | null = null;
  valid = false;
  loading = false;

  rules = {
    nome: [required()],
  };

  required = (v: any) => {
    return !!v || "Campo obrigatório";
  };

  created() {
    console.log(1);
  }

  get tituloManter(): string {
    if (this.categoria) {
      return this.categoria.idCategoria == null
        ? "Nova Categoria"
        : "Alterar Categoria";
    }
    return "";
  }

  async salvarCategoria() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      if (this.categoria) {
        await CategoriasService.manterCategoria(this.categoria);
      }
      this.loading = false;
      return modal.close(true);
    }
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async editarCategoria(id: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();
    this.categoriaPai = null;
    this.loading = true;
    this.categoria = await CategoriasService.obter(id);
    this.loading = false;

    return p;
  }

  public async novaCategoria(idPai: string) {
    const modal = this.$refs.modal as Modal;
    this.loading = true;
    const p = modal.open();
    this.categoriaPai = null;
    this.categoria = {} as Categoria;

    if (idPai != null) {
      this.categoriaPai = await CategoriasService.obter(idPai);
      this.categoria.idCategoriaPai = this.categoriaPai.idCategoria;
    }
    this.categoria.idCatalogo = this.$route.params.idCatalogo;
    this.loading = false;
    return p;
  }
}
